import React from 'react'
import { StaticImage, GatsbyImage, getImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'
import { ourImpactVideoWrap } from './Video1.module.css'

export default function Video1({ data }) {
    const { video1Text, video1Url, video1Title, video1Icon, video1BackgroundColor, video1TopPadding } = data
    return (
        <div className={`our-imapct-video-wrap global-comet-vid-wrap ${ourImpactVideoWrap} light-${video1BackgroundColor}-bg ${video1TopPadding ? '' : 'leading-global-g-sec'}`}>
            <div className='container imapct-vid-cont'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        {video1Icon && (
                            <figure className='our-impact-icon'>
                                <GatsbyImage image={getImage(video1Icon?.localFile)} alt='image' />
                            </figure>
                        )}
                        <h2 className='heading-level-2 blue-color'>{video1Title && parser(video1Title)}</h2>
                        {video1Text && parser(video1Text)}
                    </div>
                    <div className='imapact-vid-sec'>
                        <iframe
                            src={video1Url}
                            title='Impact Video'
                            width='640'
                            height='488'
                            allow='autoplay; fullscreen; picture-in-picture'
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
    )
}
